var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2083 7.00065C10.553 7.00065 10.8944 7.06855 11.2128 7.20047C11.5313 7.33239 11.8207 7.52574 12.0644 7.7695C12.3082 8.01325 12.5016 8.30263 12.6335 8.62111C12.7654 8.93959 12.8333 9.28093 12.8333 9.62565C12.8333 9.97037 12.7654 10.3117 12.6335 10.6302C12.5016 10.9487 12.3082 11.2381 12.0644 11.4818C11.8207 11.7256 11.5313 11.9189 11.2128 12.0508C10.8944 12.1828 10.553 12.2507 10.2083 12.2507H5.25346C4.49601 12.2513 3.75331 12.0413 3.10839 11.6441C2.46346 11.2468 1.94173 10.6781 1.60154 10.0013C1.26134 9.32456 1.11608 8.56652 1.182 7.81195C1.24792 7.05738 1.52242 6.33602 1.97481 5.72851C2.4272 5.12101 3.03965 4.6513 3.74368 4.37191C4.44772 4.09253 5.21558 4.01447 5.96144 4.14647C6.70729 4.27847 7.40173 4.61532 7.96712 5.11937C8.5325 5.62341 8.94655 6.27478 9.16296 7.00065H10.2083Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7352 5.24933C12.6145 4.9078 12.3907 4.61216 12.0948 4.4032C11.7989 4.19423 11.4455 4.08224 11.0832 4.08267H9.79581C9.59707 3.38044 9.16484 2.76696 8.57047 2.34346C7.9761 1.91997 7.2551 1.71177 6.52647 1.75323C5.79784 1.79469 5.10511 2.08333 4.56262 2.57152C4.02013 3.0597 3.66029 3.71826 3.54248 4.4385",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAi);
export default __webpack_public_path__ + "static/media/cloudAI.15ad40df6fb6c58e46e3be7758b1b623.svg";
export { ForwardRef as ReactComponent };